import { OrderStatus } from "src/shared/backend-api.types";

export const OrderStatusDisplay: Record<OrderStatus, string> = {
  cancelled: "Cancelled",
  completed: "Completed",
  inProgress: "In Progress",
  new: "New",
  pending: "Pending",
};

export const OrderStatusValues: OrderStatus[] = ["cancelled", "completed", "inProgress", "new", "pending"];

export const OrderStatusCompletion: OrderStatus[] = ["completed", "cancelled"];
